import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as balanceAction from "actions/balance-action";
import { formatMoney } from "utils";
import { CardInfo } from "components/card/card-info";
import PropTypes from "prop-types";
import { translate } from 'config/language';

const mapStateToProps = (state) => ({
    login: state.authReducer.loginReducer,
    balance: state.balanceReducer,
    config: state.configReducer
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        ...balanceAction
    }, dispatch);

const _CardCompanyBalance = (props) => {
    const { balance, login, config, getCompanyBalanceAction, type, benefit, useBenefit, info = null, style = {}, size = null, onInfo=null, infoButtonText=null, reload, goTo=null, goToInfo} = props;
    const [selectedBenefit, setSelectedBenefit] = React.useState(null);
    const load = async () => {
        if (login.company.master) {
            for (let system of config.system) {
                await getCompanyBalanceAction(system.code);
            }
        } else {
            await getCompanyBalanceAction();
        }
    }

    React.useEffect(() => {
        load()
    }, [login, config, reload])

    React.useEffect(() => {
        setSelectedBenefit(benefit)
    }, [benefit])

    if (type === "balance") {
        return (
            <div >
         {   benefit || useBenefit ?
                <CardInfo
                    size={size}
                    style={style}
                    info={info}
                    loading={balance.isProcessing}
                    title={balance.company.subBalances.filter(b => b.benefit === benefit)[0].nameBenefit}
                    value={formatMoney(balance.company.subBalances.filter(b => b.benefit === benefit)[0].balance)}
                />
                :
                login.company.master ?
                    balance.balances.filter(b=>b.system.toLowerCase()!=="acg").map(b =>
                        <CardInfo
                            size={size}
                            style={style}
                            info={info}
                            loading={balance.isProcessing}
                            title={b.subBalances.length === 1 ? `${b.system.toUpperCase()} - ${b.subBalances[0].nameBenefit}` : `${translate('balance')} da Empresa`}
                            value={formatMoney(b.balance)}
                        />)
                    :
                    <CardInfo
                        size={size}
                        style={style}
                        info={info}
                        loading={balance.isProcessing}
                        title={balance.company.subBalances.length === 1 ? "Saldo Geral" : `${translate('balance')} da Empresa`}
                        value={formatMoney(balance.company.balance)}
                    />
    }
</div>

        );
    } else if (type === "discount") {
        return (
            <CardInfo
                size={size}
                style={style}
                info={info}
                loading={balance.isProcessing}
                title="Limite Disponível"
                value={formatMoney(benefit || useBenefit ? balance.company.subBalances.filter(b => b.benefit === benefit)[0].available : balance.company.available)} />
        );
    } else if (type === "charge") {
        const total = balance.company.pendingPreCharge;
        return (
            <CardInfo
                size={size}
                style={style}
                info={info}
                loading={balance.isProcessing}
                title="Total de cargas pendentes"
                value={formatMoney(total)}
                onInfo={onInfo}
                infoButtonText={total > 0 ? infoButtonText : null}
                goTo={goTo}
                goToInfo={goToInfo}
            />
        );
    } else if (type === "scheduled") {
        const total = balance.company.scheduledCharges;
        return (
            <CardInfo
                size={size}
                style={style}
                info={info}
                loading={balance.isProcessing}
                title="Pedidos agendados"
                value={formatMoney(total)}
                onInfo={onInfo}
                infoButtonText={total > 0 ? infoButtonText : null}
                goTo={goTo}
                goToInfo={goToInfo}
            />
        );
    } else return undefined;
};

_CardCompanyBalance.defaultProps = {
    type: "balance",
    benefit: null,
    useBenefit: false
};

_CardCompanyBalance.propTypes = {
    type: PropTypes.oneOf(["balance", "discount", "charge"]),
    benefit: PropTypes.any,
    useBenefit: PropTypes.bool
};

const CardCompanyBalance = connect(mapStateToProps, mapDispatchToProps)(_CardCompanyBalance);

export { CardCompanyBalance }
